<template>
  <div class="login-container">
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-md-6 col-lg-4">
          <div class="card shadow">
            <div class="card-body p-4">
              <div class="text-center mb-4">
                <h2 class="card-title">Bejelentkezés</h2>
                <p class="text-muted">Partner portál</p>
              </div>

              <form @submit.prevent="handleLogin">
                <div class="mb-3">
                  <label for="email" class="form-label">E-mail cím</label>
                  <input
                    type="email"
                    class="form-control"
                    id="email"
                    v-model="form.email"
                    :class="{ 'is-invalid': errors.email }"
                    required
                  >
                  <div v-if="errors.email" class="invalid-feedback">
                    {{ errors.email }}
                  </div>
                </div>

                <div class="mb-3">
                  <label for="password" class="form-label">Jelszó</label>
                  <input
                    type="password"
                    class="form-control"
                    id="password"
                    v-model="form.password"
                    :class="{ 'is-invalid': errors.password }"
                    required
                  >
                  <div v-if="errors.password" class="invalid-feedback">
                    {{ errors.password }}
                  </div>
                </div>

                <div class="mb-3 form-check">
                  <input
                    type="checkbox"
                    class="form-check-input"
                    id="remember"
                    v-model="form.remember"
                  >
                  <label class="form-check-label" for="remember">
                    Emlékezz rám
                  </label>
                </div>

                <button
                  type="submit"
                  class="btn btn-primary w-100"
                  :disabled="loading"
                >
                  <span v-if="loading" class="spinner-border spinner-border-sm me-2"></span>
                  Bejelentkezés
                </button>
              </form>

              <div class="text-center mt-3">
                <router-link to="/forgot-password" class="text-decoration-none d-block mb-2">
                  Elfelejtette a jelszavát?
                </router-link>
                <p class="mb-0">
                  Még nincs fiókod? 
                  <router-link to="/register" class="text-decoration-none">
                    Regisztrálj itt
                  </router-link>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import authService from '@/services/authService'
import Swal from 'sweetalert2'

export default {
  name: 'LoginView',
  data() {
    return {
      form: {
        email: '',
        password: '',
        remember: false
      },
      errors: {},
      loading: false
    }
  },
  methods: {
    async handleLogin() {
      this.loading = true
      this.errors = {}

      const result = await authService.login(this.form.email, this.form.password)

      if (result.success) {
        Swal.fire({
          icon: 'success',
          title: 'Sikeres bejelentkezés!',
          text: `Üdvözöljük, ${result.user.last_name}!`,
          timer: 2000,
          showConfirmButton: false
        })
        
        // Ellenőrizzük, hogy van-e mentett redirect útvonal
        const redirectPath = sessionStorage.getItem('redirectAfterLogin')
        if (redirectPath) {
          sessionStorage.removeItem('redirectAfterLogin')
          this.$router.push(redirectPath)
        } else {
          this.$router.push('/')
        }
      } else {
        Swal.fire({
          icon: 'error',
          title: 'Bejelentkezési hiba',
          text: result.message
        })
      }

      this.loading = false
    }
  }
}
</script>

<style scoped>
.login-container {
  min-height: 100vh;
  background: linear-gradient(135deg, #F1EEEF 0%, #d3d2d2 100%);
  display: flex;
  align-items: center;
}

.card {
  border: none;
  border-radius: 15px;
}

.btn-primary {
  background: linear-gradient(135deg, #1d4699 0%, #163980 100%);
  border-color: #1d4699;
  color: white;
}

.btn-primary:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(41, 142, 179, 0.4);
}
</style>